'use client'

import { formatDateTimeLong, formatImageURL } from "@/utils/util"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"

export default function BlogCard({ blog, index = 0 }: { blog: any, index?: number}) {
  const pathname = usePathname()
  return (
    <a href={navigateUrl(`/blog/${blog.id}`, pathname)} className="relative rounded-lg aspect-[16/9] border border-muted bg-bg">
      <div className="h-[50%] w-full absolute left-0 bottom-0 bg-linear-to-b from-transparent to-zinc-800/75 z-10 rounded-br-lg rounded-bl-lg" />
      {blog.thumbnail ? (
        <img className="w-full h-full object-cover rounded-lg z-0" src={formatImageURL(blog.thumbnail)} alt={blog.title} />
      ) : (
        <img className="w-full h-full object-cover rounded-lg z-0" src={formatImageURL('placeholder.png')} alt={blog.title} />
      )}
      <div className="absolute left-4 bottom-2 z-20">
        <h2 className="text-lg font-semibold text-zinc-50 leading-5">{blog.title}</h2>
        <p className="text-xs font-medium mt-1 text-zinc-200">{formatDateTimeLong(blog.createdAt)}</p>
      </div>
    </a>
  )
}